import { BetBasicInfo } from "@tvg/ts-types/Bet";
import { Selections } from "@tvg/ts-types/Selections";

const formatRaceWagersWithAlternates = <
  T extends BetBasicInfo | BetBasicInfo[]
>(
  wagers: T
): T => {
  const wagersArray = Array.isArray(wagers) ? wagers : [wagers];

  const formattedWagers = wagersArray.map((wager) => {
    if (!wager.selections?.selection) return wager;

    return {
      ...wager,
      selections: {
        ...wager.selections,
        selection: wager.selections.selection.map((selection: Selections) => {
          if (!selection.bettingInterests) return selection;

          const updatedBettingInterests = [...selection.bettingInterests];
          const updatedRunners = [...(selection.runners || [])];

          if (
            selection.alternateBettingInterest &&
            selection.alternateBettingInterest.biNumber !== 0 &&
            selection.alternateBettingInterest.runners?.length
          ) {
            updatedBettingInterests.push({
              ...selection.alternateBettingInterest,
              isAlternate: true
            });

            if (selection.alternateBettingInterest.biNumber) {
              updatedRunners.push({
                // @ts-ignore
                number: `${selection.alternateBettingInterest.biNumber}B`
              });
            }
          }

          return {
            ...selection,
            bettingInterests: updatedBettingInterests,
            runners: updatedRunners
          };
        })
      }
    };
  });

  return (Array.isArray(wagers) ? formattedWagers : formattedWagers[0]) as T;
};

export default formatRaceWagersWithAlternates;
